import { createFileRoute, redirect } from "@tanstack/react-router";
import { AppShell } from "@/components/AppShell";
import { getToken } from "@/lib/api";
import { rememberPostAuthDestination } from "@/auth/postAuthDestination";

export const Route = createFileRoute("/_auth")({
  beforeLoad: () => {
    if (!getToken()) {
      rememberPostAuthDestination();
      throw redirect({ to: "/login" });
    }
  },
  component: AppShell,
});
